import http from './http'

const Share =  {
    share_config:{},
    wx_share:0,
    wxShare(wx_share,config = false){
        this.wx_share = wx_share;
        var url = window.location.href;
        this.share_config = config || {
            title:"8月21日邀请您参加2026戴尔科技峰会",
            desc:"本届峰会将围绕“核心困局 vs. 破局路径” 进行深入探讨。",
            link:url,
            imgUrl:"https://www.dellemc-solution.com/dtf-2026/front/img/share.png"
        };
        this.loadJs();
    },
    loadJs(){
        http.request({
            api:"wx/getShareSdk",
            data:{
                url:window.location.origin+window.location.pathname+window.location.search
            },
            success:(res)=>{
                var jssdkconfig = res.config;
                jssdkconfig.appId = jssdkconfig.wxAppId;
                jssdkconfig.timestamp = parseInt(jssdkconfig.timestamp);
                jssdkconfig.debug = false;
                jssdkconfig.jsApiList = [
                    'updateAppMessageShareData',
                    'updateTimelineShareData'
                ];
                wx.config(jssdkconfig);
                this.init();
            }
        })
    },
    init(){
        if (typeof WeixinJSBridge == "undefined"){
            if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', this.wxReady(), false);
            }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', this.wxReady());
                document.attachEvent('onWeixinJSBridgeReady', this.wxReady());
            }
        }else{
            this.wxReady()
        }
    },
    wxReady(){
        wx.ready(()=> {
            this.doShare();
        });
        this.doShare();
    },
    doShare(){
        var data = this.share_config;
        wx.updateAppMessageShareData({
            title: data.title,
            desc: data.desc,
            link:data.link,
            imgUrl: data.imgUrl,
            success : function(msg){
                console.log('updateAppMessageShareData success')
            },
            error:function (res) {

            }
        });
        wx.updateTimelineShareData({
            title:data.title,
            link:data.link,
            imgUrl: data.imgUrl,
            success : function(msg){
                console.log('updateTimelineShareData success')
            },
            error:function (res) {

            }
        });
    }
};

export default Share;
